// extracted by mini-css-extract-plugin
export default {"container":"SuggestedSuppliers_container__V+KVG","wrapper":"SuggestedSuppliers_wrapper__6USBY","tag":"SuggestedSuppliers_tag__a6JTu"};